import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input, Pagination, Spin } from "antd";
import { BlogApi } from "../../api/blog";
const { Search } = Input;

function Blog() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const getBlogs = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        search: searchText,
        limit : 6
      };
      const { data } = await BlogApi(params);
      if (data?.status) {
        const pagination = data?.data?.pagination || {};
        const formattedData = data?.data?.blogs?.map((item) => ({
          id: item?.id,
          title: item?.title,
          desc: item?.desc,
          image: item?.image,
          created_at: new Date(item?.date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
        }));

        setBlogs(formattedData || []);
        setTotalRecords(pagination?.total || 0);
        setPageSize(pagination?.per_page || 6);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBlogs();
  }, [page, searchText]);

  const handleSearch = (value) => {
    setSearchText(value);
    setPage(1);
  };

  return (
    <div className="website-container">
      <div className="flex justify-end mb-4 md:px-5 px-2">
        <Search
          placeholder="Search blogs..."
          onSearch={handleSearch}
          enterButton
          allowClear
          style={{ width: 300 }}
        />
      </div>

      {loading ? (
        <p className="h-[500px] flex justify-center items-center">
          <Spin size="large" />
        </p>
      ) : (
        <>
          <div className="grid lg:grid-cols-3 xl:gap-10 md:gap-8 gap-6 md:px-5 px-2 py-5">
            {blogs.map((data) => (
              <div
                className="blog-slider transition-transform transform hover:-translate-y-2"
                key={data.id}
              >
                <div className="bg-white shadow-md rounded-2xl overflow-hidden flex flex-col h-full">
                  {data?.image && (
                    <div className="relative">
                      <img
                        src={data.image}
                        alt={data.title}
                        className="w-full h-72 object-cover"
                      />
                      {data.created_at && (
                        <span className="absolute top-0 right-0 bg-[#0bafd4] text-white text-xs font-semibold px-4 py-2 rounded-md shadow-md">
                          {data.created_at}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex-1 flex flex-col p-4">
                    <h5 className="primary-color xl:text-[20px] md:text-[18px] text-[16px] font-semibold mb-3 leading-snug cursor-pointer">
                      {data.title}
                    </h5>
                    <div
                      className="mb-4 line-clamp-4 prose"
                      dangerouslySetInnerHTML={{ __html: data?.desc }}
                    />

                    <div className="flex items-center justify-between mt-auto">
                      <p
                        className="text-[#1e4387] font-medium text-sm hover:underline cursor-pointer"
                        onClick={() => navigate(`/blog/${data?.id}`)}
                      >
                        Read More →
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center mt-6">
            <Pagination
              current={page}
              pageSize={pageSize}
              total={totalRecords}
              showSizeChanger={false}
              onChange={(pageNumber) => setPage(pageNumber)}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default Blog;
